import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  template: `
    @if (data?.length) {
      @if (!loading) {
        @for (link of data; track link.text) {
          <div class="link">
            {{ link.text }}
            @if (link.url && !loading) {
              <nb-icon icon="external-link-outline" (click)="goToLink($event, link.url)"></nb-icon>
            }
          </div>
        }
      } @else {
        <i class="fa fa-spinner fa-spin"></i>
      }
    } @else {
      -
    }
    `,
  styleUrls: ['./multiple-link-cell.component.scss'],
})
export class MultipleLinkCellComponent {
  @Input()
  data: any;
  loading: boolean = false;

  constructor(
    private router: Router
  ) { }

  goToLink(event: any, url: string) {
    event.preventDefault();
    event.stopPropagation();
    this.loading = true;
    this.router.navigate([url], { queryParams: { ignorePreviousParams: true } });
  }
}
